<div class="chip-button-container" [attr.data-test]="'selected-adhoc-sources'">
  @for (item of adHocSources; track $index) {
    <button
      class="chip-button"
      mat-stroked-button
      color="primary"
      [attr.data-test]="'adhoc-csv'"
      [attr.data-testid]="getFileName(item)"
      (click)="onSourceClick(item)"
      [matTooltip]="getToolTip(item)">
      {{ getFileName(item) }}
    </button>
  } @empty {
    <mat-chip class="empty chip-text-color-inherit" disabled="true">{{
      'None Found' | translate: locale.language
    }}</mat-chip>
  }
</div>
